import {GridPhoto} from 'platform/components';

import {chain, defaultTo, map, pipe, uniq} from 'ramda';

import {
  AuditDataAssetsBody,
  AuditDataAssetsFilesBody,
  LoadAuditDataCategories,
} from '@dms/api/core';

export const getGridPhotosFromAudit = (auditCategories?: LoadAuditDataCategories[]) =>
  pipe(
    defaultTo<LoadAuditDataCategories[]>([]),
    chain((category: LoadAuditDataCategories) => category.assets),
    chain((audit: AuditDataAssetsBody) => audit.files),
    uniq,
    map<AuditDataAssetsFilesBody, GridPhoto>((file) => ({
      url: file.url,
      originalUrl: file.url,
      resizeUrl: file.resizeUrl,
      id: file.uploadedAssetId,
      makeUrl: (url, width) => `${url}&width=${width}`,
    }))
  )(auditCategories);
